(function () {
  var restoreScrollAfterReviewClick = function () {
    var scrollX = window.pageXOffset;
    var scrollY = window.pageYOffset;

    window.setTimeout(function () {
      window.scrollTo(scrollX, scrollY);
    }, 0);

    window.setTimeout(function () {
      window.scrollTo(scrollX, scrollY);
    }, 250);
  };

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest('.template-product .jdgm-review-widget .jdgm-write-rev-link');

    if (!link) return;

    restoreScrollAfterReviewClick();
  });
})();
